import React from 'react';
import FilterContainer from '@components/filter-panel';
import { DASHBOARD_TYPE } from '@utils/constants';

const FilterContainerWrapper = ({
  mode, nocFilters, maxSelectedFilters, maxFilters,
}) => (
  <FilterContainer
    dashboardId="new"
    dashboardType={DASHBOARD_TYPE.NOC}
    nocMode={mode}
    maxSelectedFilters={maxSelectedFilters}
    maxFilters={maxFilters}
    selectedFilterNames={nocFilters.map(item => item.name)}
  />
);

export default React.memo(FilterContainerWrapper);
